require('./filterFormController');
require('../../datePickerPopup/datePickerPopupDirective');
require("./../../searchDropDown/searchDropDownDirective");

angular.module('app.shared.clipSearch.filterFormDirective', [
  'app.shared.clipSearch.filterFormDirective.filterFormController',
  'app.shared.datePickerPopup.datePickerPopupDirective',
  'app.shared.searchdDropDown.searchDropDownDirective'
])
  .directive('clipSearchFilterForm', [
    () => {
      "use strict";

      return {
        restrict: 'E',
        templateUrl: 'components/shared/clipSearch/filterFormDirective/filterFormDirectiveView.html',
        controller: 'app.shared.clipSearch.filterFormDirective.filterFormController',
        scope: {
          filterData: '=',
          showPresetActions: '=?',
          defaultValue: '=?'
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/clipSearch/filterFormDirective/filterFormDirective.js